import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["customReplace"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import TimePickerPanel, { DefaultCustomReplace } from '../TimePickerPanel';
var TimePanel = {
  timePanel: true,
  type: 'time',
  label: '时间',
  echo: function echo(value) {
    return value;
  },
  render: function render(_ref) {
    var _customReplace;

    var title = _ref.title,
        value = _ref.value,
        _update = _ref.update,
        _ref$config = _ref.config,
        customReplace = _ref$config.customReplace,
        config = _objectWithoutProperties(_ref$config, _excluded);

    customReplace = (_customReplace = customReplace) !== null && _customReplace !== void 0 ? _customReplace : DefaultCustomReplace(config);
    return {
      notCloseWhenUpdate: true,
      dropdown: /*#__PURE__*/React.createElement(TimePickerPanel, _extends({}, _objectSpread(_objectSpread({}, config), {}, {
        customReplace: customReplace
      }), {
        title: title,
        value: value,
        update: function update(idx, text) {
          _update(customReplace(value, idx, text));
        }
      }))
    };
  }
};
export default TimePanel;